import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

const FinalCta = ({ onBookClick }) => {
  const { t } = useI18n();
  return (
    <section id="contact" className="py-20 md:py-32 bg-white" data-testid={TIDS.finalCtaSection}>
      <div className="zdc-container">
        <div className="relative rounded-3xl bg-[#111111] text-white overflow-hidden p-10 md:p-16 lg:p-20">
          {/* Decorative grid */}
          <div className="absolute inset-0 opacity-[0.06]" style={{
            backgroundImage: "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
            backgroundSize: "48px 48px"
          }} />
          {/* Decorative blue blob */}
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#2563EB] opacity-30 blur-[100px]" />

          <div className="relative max-w-2xl">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1]">
              {t.finalCta.title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/70 max-w-xl">{t.finalCta.subtitle}</p>
            <button
              data-testid={TIDS.finalCtaBtn}
              onClick={onBookClick}
              className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-white text-[#111111] font-medium text-sm hover:bg-[#F5F7FA] transition-all hover:translate-y-[-1px] hover:shadow-2xl"
            >
              {t.finalCta.cta}
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
